module.exports = __webpack_public_path__ + "media/images/sales/set/eyecatch-set-02-summmer-74dcdcf6aeb3ffc8381bef7fe3f69d31.svg";